/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Japanese
export default {
  'project-actions.project-content.archive-error-title': 'プロジェクトを復元できませんでした',
  'project-actions.project-content.archive-project': 'プロジェクトをアーカイブ',
  'project-actions.project-content.archive-restore-error-description':
    'プロジェクトの変更を保存できませんでした。後でもう一度お試しください。',
  'project-actions.project-content.copy-link': 'リンクをコピー',
  'project-actions.project-content.copy-project': 'プロジェクトをコピー',
  'project-actions.project-content.copy-project.cancel': 'キャンセル',
  'project-actions.project-content.copy-project.close-modal': 'モーダルを閉じる',
  'project-actions.project-content.copy-project.error': 'プロジェクトの内容をわかりやすく表す名前を付けてください',
  'project-actions.project-content.copy-project.failed-description':
    'プロジェクトの複製中にエラーが発生しました。後でもう一度お試しください。',
  'project-actions.project-content.copy-project.failed-description-forbidden':
    'このプロジェクトをコピーする権限がありません。',
  'project-actions.project-content.copy-project.failed-title': 'このプロジェクトを複製できませんでした。',
  'project-actions.project-content.copy-project.followers': 'フォロワー',
  'project-actions.project-content.copy-project.include': '含める',
  'project-actions.project-content.copy-project.links': 'リンク',
  'project-actions.project-content.copy-project.project-name': 'プロジェクト名',
  'project-actions.project-content.copy-project.submit': '送信',
  'project-actions.project-content.copy-project.success-description': 'プロジェクトは正常に複製されました。',
  'project-actions.project-content.copy-project.success-link': '複製されたプロジェクトを表示します。',
  'project-actions.project-content.copy-project.success-title': 'プロジェクト「{projectName}」が複製されました。',
  'project-actions.project-content.copy-project.title': 'プロジェクトをコピー',
  'project-actions.project-content.follow': 'フォロー',
  'project-actions.project-content.follow-confirmation-description':
    '毎週月曜日の朝に、フォロー中のすべてのプロジェクトに関する最新情報のダイジェストが届きます。月曜日が最適である理由については、<a>こちらをご覧ください</a>。',
  'project-actions.project-content.follow-confirmation-title': '🙌🏼 このプロジェクトをフォロー中です!',
  'project-actions.project-content.follow-error-title': 'プロジェクトをフォローできませんでした',
  'project-actions.project-content.follow-unfollow-error-description':
    'プロジェクトの変更を保存できませんでした。後でもう一度お試しください。',
  'project-actions.project-content.restore-project': 'プロジェクトを復元',
  'project-actions.project-content.share': '共有',
  'project-actions.project-content.unfollow': 'フォローを解除',
  'project-actions.project-content.unfollow-error-title': 'プロジェクトのフォローを解除できませんでした',
};
